const initHeroSlideshow = () => {
	
	window.addEventListener('DOMContentLoaded', () => {
		const heroSlideshow = document.querySelector('[data-swiper]');
		const isAutoplay = Boolean(heroSlideshow.getAttribute('data-swiper-autoplay'));
		const autoplaySpeed = Number(heroSlideshow.getAttribute('data-autoplay-speed')) * 1000;
		
		new Swiper(heroSlideshow, {
			loop: true,
			autoplay: isAutoplay ? {
				delay: autoplaySpeed,
			} : isAutoplay,
			navigation: {
				nextEl: ".hero-slideshow__swiper-button--next",
				prevEl: ".hero-slideshow__swiper-button--prev",
			},
			pagination: {
				el: ".swiper-pagination",
			},
		})
	})
}

initHeroSlideshow();